export const AGENCIES = {
  'artois.ptitservices': {
    id: 'artois.ptitservices',
    name: 'Agence Artois',
    subdomain: 'artois.ptitservices.com',
    phone: '03 74 47 47 82',
    phoneRaw: '0374474782',
    email: 'contact@artois.ptitservices.com',
    address: '61 rue de la mairie',
    city: '62530 Servins',
    region: 'Pas-de-Calais (62)',
    lat: 50.3816,
    lng: 2.6911,
    radiusKm: 40,
    zones: [
      {
        region: 'Agglomération de Lens-Liévin',
        cities: ['Lens', 'Liévin', 'Avion', 'Méricourt', 'Sallaumines', 'Billy-Montigny', 'Wingles', 'Harnes', 'Bully-les-Mines', 'Noyelles-sous-Lens', 'Grenay', 'Loos-en-Gohelle', 'Angres', 'Givenchy-en-Gohelle', 'Souchez', 'Ablain-Saint-Nazaire', 'Carency', 'Vimy']
      },
      {
        region: 'Agglomération de Béthune-Bruay',
        cities: ['Béthune', 'Bruay-la-Buissière', 'Nœux-les-Mines', 'Barlin', 'Auchel', 'Lillers', 'Houdain', 'Hersin-Coupigny', 'Marles-les-Mines', 'Divion', 'Labourse', 'Beuvry', 'Annezin', 'Fouquières-lès-Béthune', 'Verquin', 'Hesdigneul-lès-Béthune']
      },
      {
        region: 'Arrageois',
        cities: ['Arras', 'Saint-Laurent-Blangy', 'Saint-Nicolas', 'Sainte-Catherine', 'Anzin-Saint-Aubin', 'Achicourt', 'Beaurains', 'Dainville', 'Athies', 'Fampoux', 'Roclincourt', 'Neuville-Saint-Vaast', 'Thélus', 'Marœuil', 'Mont-Saint-Éloi', 'Aubigny-en-Artois']
      },
      {
        region: 'Bassin minier & Hénin-Carvin',
        cities: ['Hénin-Beaumont', 'Carvin', 'Libercourt', 'Oignies', 'Courrières', 'Leforest', 'Montigny-en-Gohelle', 'Drocourt', 'Rouvroy', 'Évin-Malmaison', 'Courcelles-lès-Lens', 'Noyelles-Godault']
      },
      {
        region: 'Ternois & campagne',
        cities: ['Saint-Pol-sur-Ternoise', 'Frévent', 'Avesnes-le-Comte', 'Pernes', 'Bours', 'Amettes', 'Tangry', 'Cambligneul', 'Camblain-l\'Abbé', 'Gouy-Servins', 'Villers-au-Bois', 'Bouvigny-Boyeffles', 'Servins']
      },
      {
        region: 'Secteur Douaisis (limite)',
        cities: ['Douai', 'Cuincy', 'Lambres-lez-Douai', 'Flers-en-Escrebieux', 'Esquerchin', 'Izel-lès-Équerchin']
      }
    ]
  },
};

export const getAgency = (id) => AGENCIES[id];
export const getAllAgencies = () => Object.values(AGENCIES);
